export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14486.ed7194c7.jpg";